module.exports = __webpack_public_path__ + "img/AccessTime.37c2f092.svg";